import React, { Component } from "react";
import { Col, message, PageHeader, Row, Spin, Space, Tabs, Select } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";

import {
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  SelectItem,
} from "../../../../Components/Items";
import reporteDePagosProveedoresPdf from "../../../../Pdf/reporteDePagosProveedoresPdf";

moment.locale("es");
const { Option } = Select;
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;

class ReportePagosAProveedores extends Component {
  state = {
    loading: false,
    dataReporte: null,
    pagos: [],
    dataGrafico: [],
    total: 0,
    proveedores: [],
    loadingProveedores: false,
  };

  atras = () => {
    this.props.history.goBack();
  };

  componentDidMount() {
    this.cargarProveedores();

    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  cargarProveedores = async () => {
    this.setState({ loadingProveedores: true });

    try {
      const res = await axios.post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      const proveedores = res.data?.proveedores || res.data || [];

      this.setState({
        objetoProveedores: proveedores.map((p) => {
          const nombre = p.persona
            ? p.razonSocial
            : `${p.nombre || ""} ${p.apellidoPaterno || ""} ${p.apellidoMaterno || ""}`.trim();

          return (
            <Option key={p._id} value={p._id}>
              {nombre}
            </Option>
          );
        }),
        loadingProveedores: false,
      });
    } catch {
      this.setState({ objetoProveedores: [], loadingProveedores: false });
    }
  };



  async crearGrafico(valuePagos, fechaInicial, fechaFinal) {
    let grafico = [];
    let graficoSumatoria = [];
    let sumatoria = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    // ===== POR DÍA =====
    if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
      while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
        const fechaActual = fechaCambiante.clone();

        const pagosDelBloque = valuePagos.filter((p) =>
          moment(p.fechaPago, "DD/MM/YYYY").isSame(fechaActual, "day")
        );

        const totalBloque = pagosDelBloque.reduce(
          (acc, p) => acc + Number(p.monto || 0),
          0
        );

        grafico.push({
          x: fechaActual.format("DD/MM/YYYY"),
          y: totalBloque,
        });

        graficoSumatoria.push({
          x: fechaActual.format("DD/MM/YYYY"),
          y: totalBloque + sumatoria,
        });

        sumatoria += totalBloque;
        fechaCambiante.add(1, "day");
      }

      // ===== POR SEMANA =====
    } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
      while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
        const fechaActual = fechaCambiante.clone();

        const pagosDelBloque = valuePagos.filter((p) =>
          moment(p.fechaPago, "DD/MM/YYYY").isSame(fechaActual, "week")
        );

        const totalBloque = pagosDelBloque.reduce(
          (acc, p) => acc + Number(p.monto || 0),
          0
        );

        grafico.push({
          x: fechaActual.format("DD/MM/YYYY"),
          y: totalBloque,
        });

        graficoSumatoria.push({
          x: fechaActual.format("DD/MM/YYYY"),
          y: totalBloque + sumatoria,
        });

        sumatoria += totalBloque;
        fechaCambiante.add(1, "week");
      }

      // ===== POR MES =====
    } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
      while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
        const fechaActual = fechaCambiante.clone();

        const pagosDelBloque = valuePagos.filter((p) =>
          moment(p.fechaPago, "DD/MM/YYYY").isSame(fechaActual, "month")
        );

        const totalBloque = pagosDelBloque.reduce(
          (acc, p) => acc + Number(p.monto || 0),
          0
        );

        grafico.push({
          x: fechaActual.format("MM/YYYY"),
          y: totalBloque,
        });

        graficoSumatoria.push({
          x: fechaActual.format("MM/YYYY"),
          y: totalBloque + sumatoria,
        });

        sumatoria += totalBloque;
        fechaCambiante.add(1, "month");
      }

      // ===== POR AÑO =====
    } else {
      while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
        const fechaActual = fechaCambiante.clone();

        const pagosDelBloque = valuePagos.filter((p) =>
          moment(p.fechaPago, "DD/MM/YYYY").isSame(fechaActual, "year")
        );

        const totalBloque = pagosDelBloque.reduce(
          (acc, p) => acc + Number(p.monto || 0),
          0
        );

        grafico.push({
          x: fechaActual.format("YYYY"),
          y: totalBloque,
        });

        graficoSumatoria.push({
          x: fechaActual.format("YYYY"),
          y: totalBloque + sumatoria,
        });

        sumatoria += totalBloque;
        fechaCambiante.add(1, "year");
      }
    }

    this.setState({
      dataGrafico: [
        { id: "Pagos", data: grafico },
        { id: "Pagos Acumulados", data: graficoSumatoria },
      ],
    });
  }


  consultarReporte = (values) => {
    this.setState({ loading: true });

    const fechaInicial = values.periodo[0].format("YYYY-MM-DD");
    const fechaFinal = values.periodo[1].format("YYYY-MM-DD");

    axios
      .post(
        "reportesAdministrativos/reportePagosProveedores",
        {
          empresaId: this.props.empresaId,
          fechaInicial,
          fechaFinal,
          proveedorId: values.proveedorId || null,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data?.pagos) {
          // Para el gráfico usamos el mismo formato que tu reporte original: DD/MM/YYYY
          const pagos = res.data.pagos || [];
          const total = res.data.total || 0;

          this.crearGrafico(pagos, fechaInicial, fechaFinal);

          this.setState({
            loading: false,
            dataReporte: res.data,
            pagos,
            total,
          });
        } else {
          message.warning("No se encontraron pagos en el periodo seleccionado");
          this.setState({ loading: false, pagos: [], total: 0, dataGrafico: [] });
        }
      })
      .catch(() => {
        message.error("Error al consultar el reporte");
        this.setState({ loading: false });
      });
  };

  descargarExcel = () => {
    const datos = this.state.pagos.map((p) => ({
      Proveedor: p.proveedor,
      Factura: p.factura,
      Fecha: p.fechaPago,
      Banco: p.banco,
      Referencia: p.referencia,
      Moneda: p.moneda,
      Monto: p.monto,
    }));

    const worksheet = XLSX.utils.json_to_sheet(datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pagos a Proveedores");

    XLSX.writeFile(
      workbook,
      `Reporte_Pagos_Proveedores_${moment().format("YYYY-MM-DD")}.xlsx`
    );
  };

  descargarPdf = () => {
    pdfMake
      .createPdf(reporteDePagosProveedoresPdf(this.state.dataReporte))
      .download(`Reporte_Pagos_Proveedores_${moment().format("YYYY-MM-DD")}.pdf`);
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  render() {
    const columns = [
      { title: "Proveedor", dataIndex: "proveedor", key: "proveedor", ellipsis: true, buscar: "proveedor" },
      { title: "Factura", dataIndex: "factura", key: "factura", ellipsis: true, buscar: "factura" },
      {
        title: "Fecha",
        dataIndex: "fechaPago",
        key: "fechaPago",
        buscar: "fechaPago",
        sorter: (a, b) => {
          if (moment(a.fechaPago, "DD/MM/YYYY") < moment(b.fechaPago, "DD/MM/YYYY")) return -1;
          if (moment(a.fechaPago, "DD/MM/YYYY") > moment(b.fechaPago, "DD/MM/YYYY")) return 1;
          return 0;
        },
      },
      { title: "Banco", dataIndex: "banco", key: "banco", ellipsis: true, buscar: "banco" },
      { title: "Referencia", dataIndex: "referencia", key: "referencia", ellipsis: true, buscar: "referencia" },
      { title: "Moneda", dataIndex: "moneda", key: "moneda", width: 80, align: "center", buscar: "moneda" },
      {
        title: "Monto",
        dataIndex: "monto",
        key: "monto",
        buscar: "monto",
        align: "right",
        render: (value) => dineroDisabledMask(value),
        sorter: (a, b) => (Number(a.monto || 0) < Number(b.monto || 0) ? -1 : 1),
      },
    ];

    return (
      <Form
        name="reportePagosProveedores"
        onFinish={this.consultarReporte}
        onFinishFailed={this.onFinishFailed}
        initialValues={{
          periodo: [moment().subtract(1, "month"), moment()],
        }}
      >
        <PageHeader
          onBack={this.atras}
          title="Reporte Pagos a Proveedores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Space>
                {this.state.dataReporte && (
                  <ButtonItem blanco onClick={this.descargarExcel} icon={<FileExcelOutlined />}>
                    Descargar Excel
                  </ButtonItem>
                )}
                {this.state.dataReporte && (
                  <ButtonItem blanco onClick={this.descargarPdf} icon={<FilePdfOutlined />}>
                    Descargar PDF
                  </ButtonItem>
                )}
                <ButtonItem type="primary" htmlType="submit">
                  Consultar
                </ButtonItem>
              </Space>
            </div>
          }
        />

        <Spin spinning={this.state.loading}>
          {/* ===== FILTROS ===== */}
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              style={{ margin: 0 }}
              tabBarExtraContent={{
                left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
              }}
            >
              <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                <FormItem name="periodo" required noStyle>
                  <RangePickerItem />
                </FormItem>
              </TabPane>
              <TabPane tabKey="2" key="2" forceRender tab="Proveedor">
                <FormItem name="proveedorId">
                  <SelectItem
                    allowClear
                    placeholder="Proveedor"
                    loading={this.state.loadingProveedores}
                  >
                    {this.state.objetoProveedores}
                  </SelectItem>
                </FormItem>

              </TabPane>


            </Tabs>
          </div>

          {/* ===== GRAFICO ===== */}
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingBottom: 35,
              marginTop: 10,
              marginBottom: 10,
              height: 420,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

            <ResponsiveLine
              data={this.state.dataGrafico}
              margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

              // ✅ Tooltips tipo “línea vertical” (mucho más claro)
              enableSlices="x"
              useMesh={true}

              yFormat={(e) => dineroDisabledMask(Math.abs(e))}

              xScale={{ type: "point" }}
              yScale={{
                type: "linear",
                min: 0,
                max: "auto",
                stacked: false,
                reverse: false,
              }}

              curve="monotoneX"
              lineWidth={2}

              // ✅ Menos ruido visual
              pointSize={5}
              pointBorderWidth={1}
              pointColor={{ theme: "background" }}
              pointBorderColor={{ from: "serieColor" }}

              // Si quieres aún más limpio, descomenta:
              // enablePoints={false}

              colors={["#ff6633", "#FF926E"]}
              colorBy="index"

              axisTop={null}
              axisRight={null}

              axisBottom={{
                tickSize: 5,
                tickPadding: 8,
                tickRotation: 45,
                // ✅ muestra menos etiquetas (una de cada 2 o 3)
                tickValues: (this.state.dataGrafico?.[0]?.data || [])
                  .map(d => d.x)
                  .filter((_, i) => i % 2 === 0),
              }}

              axisLeft={{
                tickSize: 5,
                tickPadding: 8,
                format: (v) => dineroDisabledMask(Math.abs(v)),
              }}

              // ✅ Grid más limpio
              enableGridX={false}

              legends={[
                {
                  anchor: "top-right",
                  direction: "column",
                  translateX: 0,
                  translateY: 0,
                  itemWidth: 130,
                  itemHeight: 18,
                  symbolSize: 10,
                  symbolShape: "circle",
                  itemOpacity: 0.85,
                  effects: [
                    {
                      on: "hover",
                      style: {
                        itemOpacity: 1,
                      },
                    },
                  ],
                },
              ]}
            />
          </div>
          <div
            style={{
              backgroundColor: "white",
              padding: 15,
              marginBottom: 10,
              height: "75px",
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Row>
              <Col span={24} style={{ textAlign: "center" }}>
                <p style={{ margin: 0 }}>Total</p>
                <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(this.state.total)}</h1>
              </Col>
            </Row>
          </div>

          {/* ===== TABLA ===== */}
          <TableItem
            rowKey={(value, idx) => (value?._id ? value._id.toString() : String(idx))}
            columns={columns}
            dataSource={this.state.pagos}
            size="small"
            pagination={false}
          />
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReportePagosAProveedores);
